import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet';  // Import Helmet for SEO
import CareerCounselingImg from '../img/career1.png'; // Replace with a relevant image for Career Counseling

const Career_Counseling = () => {
    const cardData = [
        {
            id: 1,
            title: 'Self-Assessment',
            text: 'Career counseling begins with understanding your own skills, strengths, values, and interests. Self-assessment tools help individuals gain insight into their unique qualities, making it easier to identify the types of careers or roles that align with their personal attributes and aspirations.',
        },
        {
            id: 2,
            title: 'Exploring Career Options',
            text: 'Career counselors help individuals explore a wide range of career options based on their interests, skills, and goals. This can include researching different industries, job roles, and potential career paths, helping individuals make informed decisions about their future career direction.',
        },
        {
            id: 3,
            title: 'Educational and Skill Development',
            text: 'Career counselors provide guidance on the educational qualifications and skills required for various careers. They may suggest further studies, certifications, or skill-building courses that can enhance an individual’s qualifications and make them more competitive in their chosen field.',
        },
        {
            id: 4,
            title: 'Job Search Strategies',
            text: 'Effective job search strategies are crucial for success. Career counseling provides insights into how to navigate the job market, from utilizing job boards and networking to tailoring resumes and cover letters. Counselors teach individuals how to stand out to potential employers.',
        },
        {
            id: 5,
            title: 'Interview Preparation',
            text: 'Career counseling also focuses on interview preparation. Counselors help individuals practice common interview questions, improve their responses, and refine their interview skills. Mock interviews are often conducted to help individuals feel more confident and prepared for real interviews.',
        },
        {
            id: 6,
            title: 'Career Transitions',
            text: 'For individuals looking to switch careers or industries, career counseling is a valuable resource. It provides guidance on how to transfer existing skills to a new field, what qualifications may be necessary for a career change, and how to position oneself for success in a new professional direction.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>Career Counseling | Career Guidance and Job Search Support</title>
                <meta name="description" content="Discover career counseling services to help you assess your skills, explore career options, and succeed in your job search. Get personalized guidance on career transitions and interview preparation." />
                <meta name="keywords" content="Career Counseling, Career Guidance, Job Search, Interview Preparation, Career Transitions, Self-Assessment, Skill Development, Job Opportunities" />
                <meta name="author" content="Your Company Name" />
                <meta property="og:title" content="Career Counseling | Career Guidance and Job Search Support" />
                <meta property="og:description" content="Explore career counseling services to help you identify your strengths, research career options, enhance your skills, and navigate the job search process with confidence." />
                <meta property="og:image" content={CareerCounselingImg} />
                <meta property="og:url" content="https://yourwebsite.com/career-counseling" />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <img src={CareerCounselingImg} alt="Career Counseling" className='img-fluid h-100 w-100 rounded-md'/>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <h1 style={{fontFamily:'monospace'}} className='mb-4'>Career Counseling</h1>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Career counseling is an essential resource for individuals seeking guidance in their professional lives. Whether you're starting your career, looking for a change, or striving to advance in your current field, career counseling can provide you with the knowledge, resources, and tools you need to make informed decisions about your career path.</p>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Career counselors offer personalized advice on a range of topics, from self-assessment and skill development to job search strategies and interview preparation. They also provide support for career transitions, helping individuals successfully navigate changes in their professional lives.</p>
                    </Col>
                </Row>
            </Container>

            <Container className='mb-5'>
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className='bg-info-subtle'>
                                <Card.Body>
                                    <Card.Title style={{color:'#093c60'}} className=' fw-bold'>{card.title}</Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Career_Counseling;
